<div class="tax-lab">
  <div class="d-flex justify-content-center">
    <div class="d-flex flex-column justify-content-center tax-lab-head-line">
      <div class="text-align-center bold heading">
        <span class="target">
          <img src="../../../images/tax-lab/focus.png"/>
          <span class="ps-2 head-text">Join Our Online Tax Lab</span>
        </span>
      </div>
      <div class="text-align-center text mt-2">
        Our Tax Lab is an exclusive online arena for our subscribers to enhance their tax planning skills.
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center align-items-center">
  <div class="mt-3 mb-3 taxplan-session d-inline-flex w-auto">
    <div class="pe-2">
      <img src="../../../images/tax-lab/timer.png"/>
    </div>
    <div class="text">
      We are having a weekly session on every <span class="bold">Thursday at 1 PM CST</span>. You can register for this Zoom meeting using the button below. <span class="bold">This is exclusively for our Paid users.</span> Join us and elevate your tax planning game to new heights.
    </div>
  </div>
  </div>
  <div class="d-flex mb-3 justify-content-center">
      <button
        class="button"
        (click)="openRegistration()"
      >
        Register Here
      </button>
  </div>
  <div class="taxlab-offers">
    <div class="bold mb-2">Here's what we offer :</div>
    <div>
      <mat-accordion multi>
        <mat-expansion-panel class="tp-accordion" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="bold offer-title">
                <img src="../../../images/tax-lab/done_success.png"/>
                Interactive Tax Plan Reviews :
              </span>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <span class="offer-title">
            Every week, we open our doors to an interactive, virtual session where your tax plans take the center stage. Submit your client data, and we'll assist you in refining your strategies, supporting your client sales, and streamlining the onboarding process. It's not just a review; it's a dynamic elevation of your tax planning prowess.
          </span>
        </mat-expansion-panel>
        <mat-expansion-panel class="tp-accordion" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="bold offer-title">
                <img src="../../../images/tax-lab/done_success.png"/>
                First Come, First Serve Review Policy with Priority Hierarchy :
              </span>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <span class="offer-title">
            Our review process follows a structured hierarchy while maintaining a first-come, first-serve approach. When you upload your tax plan for review, it will be queued according to our prioritization criteria. Growth Plan users have top priority. Plans from Standard are next, followed by those from Basic plans.  Within each category, plans are reviewed on a first-come, first-serve basis. So, if you’re the first in your respective group, your plan will take the spotlight in our session. The cut-off for submission is Tuesday’s 5pm CST.
          </span>
        </mat-expansion-panel>
        <mat-expansion-panel class="tp-accordion" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="bold offer-title">
                <img src="../../../images/tax-lab/done_success.png"/>
                Preparation is Key :
              </span>
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <span class="offer-title">
            To ensure a productive and valuable session, please pre-enter the client's profile into your system and have a preliminary tax plan ready, along with any relevant, redacted documents. Your preparedness is the first step towards success.  Additionally, it's imperative to redact any sensitive or personal client information from documents submitted. Ensuring the confidentiality of your clients' information is paramount. For redacting documents, there are two recommended tools:
            <div>1. Adobe Acrobat: A well-known tool for editing PDFs, Adobe Acrobat offers robust features for redacting   sensitive information. For a detailed guide on using Adobe Acrobat for redaction, please visit <a href="https://helpx.adobe.com/acrobat/using/removing-sensitive-content-pdfs.html" target="_blank">Adobe Acrobat Redaction Guide</a>.</div>
            <div>2. Redactable is a free tool for adding redaction to PDF documents. Open the document or file containing sensitive information with Redactable <a href="https://www.redactable.com/?via=48d670" target="_blank">here</a>. For a detailed guide on using Redactable for redaction, please visit <a href="https://meyertax-8719651.hs-sites.com/en/knowledge/how-to-use-redactable-to-redact-sensitive-information-on-a-1040" target="_blank">How to Use Redactable to Redact Sensitive Information on a 1040</a>.</div>
          </span>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div class="d-flex justify-content-center" *ngIf="taxlabFiles && taxlabFiles.length === 0">
    <div class="d-flex flex-column justify-content-center mt-5 mb-5">
      <div class="text-align-center">
        <button class="alignt-items-end button small" (click)="showDisclaimer()">Upload Document</button>
        <input type="file" accept=".pdf,image/*" id="planFileUpload" (change)="startUpload($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader" multiple/>
      </div>
      <div class="text-align-center text">Once the document be uploaded, it will send the request to the support.</div>
    </div>
  </div>
  <div class="d-flex flex-column" *ngIf="taxlabFiles && taxlabFiles.length > 0">
    <div class="d-flex mt-3 mb-3 justify-content-between">
      <div class="heading">
        Tax Lab Uploaded Documents
      </div>
      <div>
        <button class="alignt-items-end button small" (click)="showDisclaimer()">Upload Document</button>
        <input type="file" accept=".pdf,image/*" id="planFileUpload" (change)="startUpload($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader" multiple/>
      </div>
    </div>
    <div class="no-hover client-todos tax-strategy client-plans badge-tables" style="height: 45vh;overflow-y: auto; padding: 0;">
      <div class="tpiq-paginated-table invoices scenarios">
        <table style="margin-top: 0 !important;">
          <thead>
          <tr>
            <th class="pointer" (click)="columnSort(column, columns)" *ngFor="let column of columns" attr.sortable="{{column['sortable'] == true}}">
              <span>{{column.title}}</span>
              <span class="float-right">
            <span *ngIf="column.sortType == 'asc'">
              <i class="icon ion-ios-arrow-up sort-indicator"></i>
            </span>
            <span *ngIf="column.sortType == 'desc'">
              <i class="icon ion-ios-arrow-down sort-indicator"></i>
            </span>
          </span>
            </th>
            <th class="pointer"></th>
          </tr>
          </thead>
          <tbody>
          <ng-template [ngIf]="taxlabFiles && taxlabFiles.length < 0">
            <tr class="text-center">
              <td [attr.colspan]="columns.length">
                <div class="callout text-center">
                  <p>No Results Found.</p>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template [ngIf]="taxlabFiles && taxlabFiles.length > 0">
            <tr *ngFor="let row of taxlabFiles">
              <td *ngFor="let col of columns;let idx=index">
                <div class="pointer data-ellipsis" *ngIf="col.name == 'documentName'" (click)="downloadDocument(row, 'preview')">
                  {{row[col.name]}}
                </div>
                <div class="pointer text-ellipsis richText-truncate" *ngIf="col.name == 'notes'">
                  <div [innerHTML]="row[col.name]"></div>
                </div>
                <div class="data-ellipsis" *ngIf="col.name != 'documentName' && col.name != 'notes' && col.name != 'status'">
                  {{row[col.name]}}
                </div>
                <div class="data-ellipsis" *ngIf="col.name == 'status' && !col['status-col']">
                  {{row[col.name]}}
                </div>
                <div class="pointer badge-tooltip indy-tables" *ngIf="col.name == 'status' && col['status-col']">
                  <div class="tpiq-paginated-table status-cell" *ngIf="!row[col.name] || row[col.name].length==0" (click)="onMouseClick($event, row, col)">
                    <a class="action">
                      <span class="name-badge name-badge-add add-icon show-on-hover add-status-icon">
                          <i class="material-icons plus-icon">add_circle_outline</i>
                      </span>
                    </a>
                  </div>
                  <div class="status-cell" *ngIf="row[col.name]">
                    <span class="status-tracker" (click)="onMouseClick($event, row, col)">{{row[col.name]}}</span>
                  </div>
                </div>
              </td>
              <td>
                <div class='badge-tooltip'>
                  <a class='action' data-action='download'>
                    <span class="doc-download">
                      <i class="icon ion-ios-cloud-download-outline pointer" (click)="downloadDocument(row, 'download')"></i>
                    </span>
                  </a>
                  <a class='action' data-action='delete'><span class='todo-del' (click)="deleteTaxlab(row)"><i class="material-icons delete">delete</i></span></a>
                </div>
              </td>
            </tr>
          </ng-template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div id="widget-container" style="height: 250px;width: 250px;z-index: 1002;position: absolute;left: -9999px;" *ngIf="displayWidget" (clickOutside)="closeContainer()">
  <div class="tpiq-input-search badge-input-search">
    <div *ngIf="selectedCol['editable']" class="option-picker-wrapper dropdown">
      <div class="wrapper-selection" *ngIf="selectedRow[selectedCol.name]">
        <div class="badge-menu-item" style="background-color: rgb(171, 170, 172)">
          <div class="item-name float-left">{{selectedRow[selectedCol.name]}}</div>
        </div>
      </div>
      <div class="wrapper-search" [hidden]="widgetLoader">
        <input type="text" placeholder="Search..." class="input-field" (keyup)="filterEntries($event)"  [(ngModel)]="dropSearchString" />
      </div>
      <div class="tpiq-loading-wheel" style="position: initial !important;height: 25vh !important" *ngIf="widgetLoader">
        <div align="center" class="fond" style="padding-top: 110px !important;">
          <div class="contener_general">
            <div class="contener_mixte"><div class="ballcolor ball_4">&nbsp;</div></div>
            <div class="contener_mixte"><div class="ballcolor ball_3">&nbsp;</div></div>
            <div class="contener_mixte"><div class="ballcolor ball_2">&nbsp;</div></div>
            <div class="contener_mixte"><div class="ballcolor ball_1">&nbsp;</div></div>
          </div>
        </div>
      </div>
      <ng-template [ngIf]="searchEntries.length > 0">
        <div class="wrapper-options">
          <div class="badge-menu-item" [style.color]="'#FFF'" *ngFor="let entry of searchEntries; let idx = index" (click)="triggerOnSelect($event, entry)">
            {{entry.name}}
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<div *ngIf="reveal['taxlabNotes']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['taxlabNotes']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 40%;" [ngClass]="{'tpiq-reveal': reveal['taxlabNotes']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Notes for tax lab</span>
      <span class="float-right pointer" (click)="hideReveal('taxlabNotes')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="medium-12">
          <label>
            Description
            <div style="min-height:50px;border:1px solid #cacaca;padding:10px;margin-bottom:20px;" [froalaEditor]="editorOptions" [(froalaModel)]="notesOfTaxlab"></div>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns row-padding-reveal">
          <button class="button small float-right" (click)="updateNotesOfTaxlab()">Update</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div [hidden]="!reveal['uploadDisclaimer']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['uploadDisclaimer']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 80%;" [ngClass]="{'tpiq-reveal': reveal['uploadDisclaimer']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Disclaimer</span>
      <span class="float-right pointer" (click)="hideReveal('uploadDisclaimer')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;max-height: 80vh;overflow-y: scroll;">
      <div class="row">
        <div class="medium-12 columns">
          <p>
            To ensure the privacy and security of sensitive data, it is important to redact any confidential information before uploading documents to TaxPlanIQ. Follow these steps to properly redact sensitive data:
          </p>
          <p>1.  Open the document or file containing sensitive information, using a reliable      document editor like Adobe Acrobat DC. We enjoy using PDF Filler free here: <a href="pdffiller.pxf.io/VmAyLM" target="_blank"></a> </p>
          <p>2.  Identify and review the data that needs to be redacted, such as names, addresses,      social security numbers, or financial account numbers.</p>
          <p>3.  Select/Search the sensitive information and apply the redaction tool to black out or remove it completely.</p>
          <p>4.  Check the document to ensure that all sensitive data has been properly redacted, including headers, footers, and any hidden or embedded information.</p>
          <p>5.  Save the redacted document with a new filename to preserve the original file.</p>
          <p>6.  For scanned documents or image files, use image editing software to manually black out or remove sensitive information, and save the edited image with a new filename.</p>
          <p>7.  Once the redaction is complete, you can safely upload the document to TaxPlanIQ or any other platform, knowing that the confidential information is protected.</p>
          <p>
            It is your responsibility to take necessary precautions and redact sensitive information properly before uploading it online. While TaxPlanIQ provides a secure platform, we do not assume responsibility for the handling or protection of sensitive data. Users are solely responsible for ensuring the privacy and security of any confidential information they upload or share on the platform.
          </p>
        </div>
        <div class="medium-12 columns text-right mt-2 mb-2">
          <label class="pointer" for="planFileUpload" style="display: initial;color: #FFFFFF;border-radius: 6px !important;padding: 0.4em 0.8em;font-size: 0.9rem;background-color: #1570EF;" (click)="hideReveal('uploadDisclaimer')">Ok</label>
        </div>
      </div>
    </div>
  </div>
</div>
